import { isCurrent } from '@/utils/bookingTypes/resolvers';
import { ORDER_STATUSES } from '@/utils/Constants';

function generateReturnTransfersQueryParams(orders) {
  return orders.reduce((acc, order) => {
    acc.placeFrom.add(order.placeToId);
    acc.placeTo.add(order.placeFromId);
    acc.class.add(order.classId);
    return acc;
  }, {
    placeFrom: new Set(),
    placeTo: new Set(),
    class: new Set(),
  });
}

function normalizeReturnTransferResponse(transfers, normalizedOrders) {
  function isValid(order) {
    return transfers.some(transfer => transfer.options
      .some(option => option.class.id === order.classId
        && option.transfer.placeFrom.id === order.placeToId
        && option.transfer.placeTo.id === order.placeFromId));
  }
  function reduceFunction(acc, order) {
    if (isValid(order)) {
      acc[order.id] = true;
    }
    return acc;
  }
  return normalizedOrders
    .reduce(reduceFunction, {});
}

export function normalizeOrders(orders) {
  return orders.map(order => ({
    id: order.id,
    placeToId: order.placeTo.id,
    placeFromId: order.placeFrom.id,
    classId: order.class.id,
  }));
}

/**
    1. Заказ не в рефьюзе
    2. У заказа нет связанного обратного трансфера
    3. Только текущие и Completed
 * @param {[]} orders
 */
export function isReturnableOrder(order) {
  return (order.status !== ORDER_STATUSES.REFUSE
    && (isCurrent(order.status) || order.status === ORDER_STATUSES.COMPLETED)
    && !order.returnTransferOrder);
}

export default function use(normalizedOrders) {
  return [
    generateReturnTransfersQueryParams(normalizedOrders),
    transfers => normalizeReturnTransferResponse(transfers, normalizedOrders),
  ];
}



// WEBPACK FOOTER //
// ./src/services/ReturnTransfers.js